import React from 'react';
import { BookOpenIcon, DocumentTextIcon, WrenchScrewdriverIcon } from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import PlaybookCard from '../../../components/playbooks/PlaybookCard';
import ResourceList from '../../../components/playbooks/ResourceList';

export default function TransparencyCharterUsefulResources() {
  const templates = [
    {
      title: "Transparency Charter Template",
      url: "https://www.openorg.fyi/resources/transparency-policy-template",
      description: "A ready-to-use template to help you document your transparency approach"
    }
  ];

  const examples = [
    {
      title: "GitLab's Approach to Transparency",
      url: "https://handbook.gitlab.com/handbook/values/#transparency",
      description: "Example of how GitLab defines, describes and documents their approach to transparency"
    },
    {
      title: "Juro's Values & DNA",
      url: "https://www.notion.so/4b584a8deb9b4320bbacb7e0c90496c2",
      description: "Example of how Juro talks about transparency as part of their core values & DNA"
    },
    {
      title: "Remote.com's Transparency Value",
      url: "https://www.notion.so/d43475e8895c4b7c811490aef64782b3",
      description: "Remote.com talks about Transparency as their value, but also lists 'anti-behaviours'"
    }
  ];

  return (
    <div className="space-y-8">
      <PlaybookSection
        title="Useful Resources"
        icon={<BookOpenIcon className="h-7 w-7 text-primary-light" />}
        heading="Templates and examples to help you build your transparency charter"
      >
        <div className="grid gap-6 md:grid-cols-2">
          <PlaybookCard>
            <div className="flex items-center mb-4">
              <WrenchScrewdriverIcon className="h-6 w-6 text-primary-light mr-3" />
              <h2 className="text-xl font-semibold text-white">Templates & Tools</h2>
            </div>
            <ResourceList items={templates} />
          </PlaybookCard>

          <PlaybookCard>
            <div className="flex items-center mb-4">
              <DocumentTextIcon className="h-6 w-6 text-primary-light mr-3" />
              <h2 className="text-xl font-semibold text-white">Example Approaches</h2>
            </div>
            <ResourceList items={examples} />
          </PlaybookCard>
        </div>
      </PlaybookSection>
    </div>
  );
} 